import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Signin from 'app/pages/signin';
import ForgotPassword from 'app/pages/forgot-password';
import SetPassword from 'app/pages/set-password';
import Profile from 'app/pages/profile';
import Faq from 'app/pages/faq';
import TermsConditions from 'app/pages/terms-conditions';
import Workouts from 'app/pages/workouts';
import WeeklyWorkouts from 'app/pages/weekly-workouts';
import Workout from 'app/pages/workout';
import WorkoutPdf from 'app/pages/workout/pdf';
import Home from 'app/pages/home';
import Resources from 'app/pages/resources';
import Resource from 'app/pages/resource';
import ResourceListHome from 'app/pages/resource-lists-home';
import ResourceList from 'app/pages/resource-list';
import OnboardingGym from 'app/pages/onboarding-gym';
import OnboardingEquipment from 'app/pages/onboarding-equipment';
import PortalAuthorization from 'app/pages/portal-authorization';
import VerifyOneFiit from 'app/pages/verify-onefiit';
import Library from 'app/pages/library';
import Collection from 'app/pages/collection';
import AuthListener from 'app/pages/auth-listener';
import Challenge from 'src/app/pages/challenge';
import TrainingPlans from 'app/pages/training-plans';
import ActiveTrainingPlans from 'app/pages/active-training-plans';
import ProgressivePlanPreview from 'app/pages/progressive-plan';
import ProgressivePlanInstance from 'app/pages/progressive-plan-instance';
import { ProtectedRoute } from 'app/routes/protected-route';
import { SigninRoute } from 'app/routes/sign-in-route';
import { TechnicalSigninRoute } from 'app/routes/technical-sign-in-route';
import { routes } from 'app/routes/constants';

import useConfig from 'app/config';

export function AppRoutes() {
  const { config } = useConfig();
  const resourceListsEnabled = config.REACT_APP_RESOURCE_LISTS_ENABLED;
  const ssoEnabled = config.REACT_APP_SSO_ENABLED;
  const newLibraryEnabled = config.REACT_APP_NEW_LIBRARY_ENABLED;

  return (
    <Routes>
      <Route element={<SigninRoute />}>
        <Route path={routes.SIGNIN} element={<Signin />} />
        <Route path={routes.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={routes.SET_PASSWORD} element={<SetPassword />} />
      </Route>
      <Route element={<TechnicalSigninRoute />}>
        <Route path={routes.TECHNICAL_SIGNIN} element={<Signin />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Home />} />
        <Route path={routes.PROFILE} element={<Profile />} />
        <Route path={routes.FAQ} element={<Faq />} />
        <Route path={routes.TERMS_CONDITIONS} element={<TermsConditions />} />
        <Route path={routes.WEEKLY_WORKOUTS} element={<WeeklyWorkouts />} />
        <Route path={routes.WORKOUTS} element={<Workouts />} />
        <Route path={routes.WORKOUT} element={<Workout />} />
        <Route path={routes.WORKOUT_PDF} element={<WorkoutPdf />} />
        <Route path={routes.ONBOARDING_GYM_TYPE} element={<OnboardingGym />} />
        <Route path={routes.ONBOARDING_GYM_EQUIPMENT} element={<OnboardingEquipment />} />
        <Route path={routes.RESOURCES} element={resourceListsEnabled ? <ResourceListHome /> : <Resources />} />
        <Route path={routes.RESOURCE} element={<Resource />} />
        {resourceListsEnabled && <Route path={routes.RESOURCE_LIST} element={<ResourceList />} />}
        {newLibraryEnabled && (
          <>
            <Route path={routes.LIBRARY} element={<Library />} />
            <Route path={routes.COLLECTIONS} element={<Library />} />
            <Route path={routes.CHALLENGES} element={<Library />} />
            <Route path={routes.COLLECTION} element={<Collection />} />
            <Route path={routes.CHALLENGE} element={<Challenge />} />
            <Route path={routes.TRAINING_PLAN} element={<ProgressivePlanPreview />} />
            <Route path={routes.TRAINING_PLANS_ACTIVE} element={<ActiveTrainingPlans />} />
            <Route path={routes.TRAINING_PLAN_ACTIVE_INSTANCE} element={<ProgressivePlanInstance />} />
            <Route path={routes.TRAINING_PLANS} element={<TrainingPlans />} />
          </>
        )}
      </Route>
      {ssoEnabled && <Route path={routes.PORTAL_AUTHORIZATION} element={<PortalAuthorization />} />}
      <Route path={routes.VERIFY_ONEFIIT} element={<VerifyOneFiit />} />
      <Route path={routes.AUTH_LISTENER} element={<AuthListener />} />
    </Routes>
  );
}
